import styled from 'styled-components';

const bgColor = '#0f131a';

export const StyledMain = styled.main`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: ${bgColor};
`;
